import { render, staticRenderFns } from "./EditBannerModal.vue?vue&type=template&id=a0521e90&scoped=true"
import script from "./EditBannerModal.vue?vue&type=script&lang=js"
export * from "./EditBannerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0521e90",
  null
  
)

export default component.exports